<template>
  <div class="product_finance">
    <div class="info">
      <div class="title">商业服务平台</div>
      <div class="content">
        技术赋能商业智能。依托认知智能引擎平台，基于专家知识经验，模块化工具组件，技术赋能商业机构数字化、智能化的业务需求，围绕营销、风控、决策和客户体验升级等行业痛点，实现在零售、金融等领域深度应用和解决方案标准化。
      </div>
    </div>
    <div class="product">
      <div class="product-catgory">
        <div class="product-catgory-item">
          <div class="product-catgory-item-title product-catgory-item-title1">
            产品矩阵
          </div>
          <ProductMatrix />
        </div>
      </div>
    </div>
    <div class="cases">
      <div class="title">客户案例</div>
      <Case :data.sync="case_list" class="case-list" />
    </div>
    <div class="visitingCard">
      <VisitingCard :data="visitlist" />
    </div>
  </div>
</template>
<script>
import Case from "@/components/customerCase.vue";
import VisitingCard from "@/components/visitingCard.vue";
import product_finance_vx from "@/../static/img/product/product_finance_vx.svg";
import ProductMatrix from "./productmatrix.vue";
export default {
  name: "product_finance",
  components: { Case, VisitingCard, ProductMatrix },
  data() {
    return {
      case_list: [
        {
          title: "BOD决策引擎",
          img: "../../../static/img/product/product_finance_case1.png",
          video: "",
          content: `BOD服务于某银行第二曲线对外服务项目，该行开放云平台和对外合作，持续拓展行业应用，为金融机构一体化风控体系建设贡献力量。并荣获<strong>${"金融大数据行业杰出产品"}。</strong>`,
          isplay: false
        }
        // {
        //   title: "小微信贷IPC线上化",
        //   img: "../../../static/img/product/product_finance_case2.png",
        //   video: "",
        //   content: `与某银行达成合作，完善银行内部风控建设，最终实现标准化线上风控流程构建、丰富银行业务产品线，提高业务收益，以及提升银行在小企业信贷<strong>${"产品设计、运营、风险控制"}</strong>等金融科技方面的能力。`,
        //   isplay: false
        // }
      ],
      visitlist: [
        // {
        //   department: "智慧金融部门联系人",
        //   name: "魏先生",
        //   vx: product_finance_vx,
        //   mail: "walfer.wei@unidt.com"
        // }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.product_finance {
  width: 100%;
  padding: 96px 0px 0px;

  .info {
    width: 100%;
    height: 632px;
    background: url("../../../../static/img/product/product_finance_bg.png")
      no-repeat 0 0 / 100%;
    overflow: hidden;

    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }

    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
    }
  }

  .plans {
    height: 820px;
    overflow: hidden;

    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }

    .plan-box {
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;

      .plan-item {
        width: 240px;
        margin-bottom: 44px;
        display: flex;
        flex-direction: column;
        align-items: center;

        > img {
          width: 180px;
          height: 180px;
        }

        .text {
          margin-top: 8px;
          font-size: 32px;
          color: #08204d;
          line-height: 44px;
        }

        .desc {
          font-size: 24px;
          color: #97a2b5;
          line-height: 52px;
        }
      }
    }
  }

  .product {
    .title {
      font-size: 40px;
      color: #08204d;
      line-height: 56px;
      text-align: center;
      margin-top: 44px;
    }

    .desc {
      margin-top: 8px;
      font-size: 24px;
      color: #97a2b5;
      line-height: 52px;
      text-align: center;
    }

    .product-catgory {
      .product-catgory-item {
        .product-catgory-item-title {
          width: 100%;
          height: 200px;
          line-height: 200px;
          font-size: 32px;
          color: #08204d;
          text-align: center;
        }

        .product-catgory-item-title1 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg1.png")
            no-repeat left center / 100%;
        }

        .product-catgory-item-title2 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg2.png")
            no-repeat left center / 100%;
        }
      }
    }
  }

  .cases {
    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }

    .case-list {
      width: calc(100% - 110px);
      margin: 24px 55px;
    }
  }

  .visitingCard {
    width: calc(100% - 128px);
    padding: 40px 64px;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/finance/index.vue